<template>
    <form class="col-12">
        <Editor
            class="nch--html-editor"
            v-model="reply.content"
            v-validate="'required'"
            :name="$t('support.tickets.reply')"
        ></Editor>
        <base-button :disabled="disabled" @click="send(reply)" type="success">
            <span class="fas fa-paper-plane mr-2"></span>
            {{$t('common.send')}}
        </base-button>
        <base-button outline @click="modal=true" type="secondary">
            <span
                class="mdi"
                :class="file.length ? 'mdi-check-circle-outline' : 'mdi-paperclip'"
            >{{$t('common.attach')}}</span>
        </base-button>
        <UploadDropzoneModal
            :modal="modal"
            @close="modal=false"
            @success="uploadSuccess"
            v-model="file"
        ></UploadDropzoneModal>
    </form>
</template>

<script>
import Editor from "../../../argon/components/Inputs/HtmlEditor";
import BaseButton from "../../../argon/components/BaseButton";
import FileInput from "../../../argon/components/Inputs/FileInput";
import UploadDropzoneModal from "../../Common/Upload/UploadDropzoneModal";

export default {
    name: "TicketReplyForm",

    components: {
        Editor,
        BaseButton,
        FileInput,
        UploadDropzoneModal
    },

    props: {
        user: Object,
        disabled: Boolean,
        value: {
            type: Object,
            required: true
        },
        send: {
            type: Function,
            default: function() {
                return this.submit();
            }
        },
    },

    data() {
        return {
            modal: false,
            file: [],
            reply: {
                content: "",
                upload: null
            }
        };
    },

    computed: {
        ticket: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        },

        replies: {
            get() {
                return this.ticket.replies;
            },
            set(replies) {
                this.ticket.replies = replies;
                this.$emit("input", this.ticket);
            }
        }
    },

    methods: {
        uploadSuccess(event) {
            this.file = event;
        },

        async submit() {
            const result = await this.$validator.validateAll();
            if (result) {
                this.$loading.show();
                if (Object.keys(this.file).length) {
                    this.reply.upload = {
                        status: 1,
                        ...this.file[0].upload
                    };
                }
                await this.sendReply();
            }
        },

        async sendReply() {
            this.$loading.show();
            const chunked = this.reply.upload.chunked;

            // Se tiver configurado como chunked, vai chamar o outro método para
            // refazer o json do upload e enviar o arquivo
            if (chunked) {
                await this.sendReplyChunked(this.reply);
                return;
            }

            return window.axios
                .post(`/api/app/tickets/reply/${this.ticket.id}`, {
                    reply: this.reply
                })
                .then(res => {
                    this.ticket.status = res.data.status;
                    this.reply = { content: "", upload: null };
                    this.push(res.data.data);
                    this.$notify({
                        type: "success",
                        message: res.data.message
                    });
                })
                .catch(err => {
                    this.$notify({
                        type: "danger",
                        message: err.response.data.error
                    });
                })
                .finally(() => {
                    this.$loading.close();
                    this.file = [];
                });
        },

        async sendReplyChunked(reply) {
            this.$loading.show();
            reply = {
                "content": reply.content,
                "upload": {
                    "status": reply.upload.status,
                    "uuid": reply.upload.uuid,
                    "progress": reply.upload.progress,
                    "total": reply.upload.total,
                    "bytesSent": reply.upload.bytesSent,
                    "filename": reply.upload.filename,
                    "chunked": reply.upload.chunked,
                    "totalChunkCount": reply.upload.totalChunkCount,
                    "path": reply.upload.path,
                    "host": reply.upload.host,
                    "hash": reply.upload.hash,
                    "type": reply.upload.type,
                    "mime": reply.upload.mime,
                    "size": reply.upload.size,
                    "original_file": reply.upload.original_file,
                    "width": reply.upload.width,
                    "height": reply.upload.height,
                    "uploadLimits": {
                        "diskUsage": reply.upload.uploadLimits.diskUsage,
                        "diskUpload": reply.upload.uploadLimits.diskUpload,
                        "diskSpace": reply.upload.uploadLimits.diskSpace,
                    }
                }
            }

            return window.axios
                .post(`/api/app/tickets/reply/${this.ticket.id}`, {
                        reply: reply
                    })
                    .then(res => {
                        this.ticket.status = res.data.status;
                        this.$notify({
                            type: "success",
                            message: res.data.message
                        });
                    })
                    .catch(err => {
                        this.$notify({
                            type: "danger",
                            message: err.response.data.error
                        });
                    })
                    .finally(() => {
                        this.$loading.close();
                        this.file = [];
                        this.reply.content = "";
                    });
        },

        push(reply) {
            this.reply.content = "";
            this.reply.upload = null;
            this.replies.push(reply);
            this.$emit("push");
        },

        filesChange(upload) {
            this.reply.upload = upload;
        },

        // async uploadFile(file) {
        //     const formData = new FormData();
        //     formData.append("uploadHost", window.axios.APP_HOST);
        //     formData.append("file", file);

        //     return axios({
        //         headers: {
        //             Authorization: "639dd5a0a149ddbd1be06e682808d16d65377c7b",
        //             "content-type": "multipart/form-data"
        //         },
        //         method: "post",
        //         url: window.axios.ASSETS_API + "/upload",
        //         data: formData
        //     })
        //         .then(res => {
        //             this.reply.upload = {
        //                 path: res.data.filePath,
        //                 host: res.data.host,
        //                 filename: res.data.name,
        //                 hash: res.data.hash,
        //                 original_file: res.data.original_file,
        //                 type: res.data.type,
        //                 mime: res.data.mime,
        //                 size: res.data.size,
        //                 status: 1,
        //                 width: res.data.width,
        //                 height: res.data.height,
        //                 author_id: this.user.id
        //             };
        //             this.file = {};
        //             return true;
        //         })
        //         .catch(err => {
        //             this.$notify({
        //                 type: "danger",
        //                 message: this.$t("common.upload_error")
        //             });
        //             this.file = {};
        //             return false;
        //         });
        // }
    }
};
</script>

<style>
.nch--html-editor {
    width: 100%;
}
</style>